// Six things a page's opening text needs before it is worth Google's time,
// each with what to do when it is missing. Read from the HTML, so it judges
// what the writer typed, whichever way they typed it.

const clean = (text) => text.replace(/\s+/g, " ").trim();
const words = (text) => (clean(text) ? clean(text).split(" ").length : 0);

export const checklist = (html, { name = "", lang = "en" } = {}) => {
  const doc = new DOMParser().parseFromString(`<body>${html || ""}</body>`, "text/html");
  const text = (element) => (element ? clean(element.textContent) : "");
  const headline = text(doc.querySelector("h2"));
  const links = doc.querySelectorAll('a[href^="/"], a[href^="https://nysmah.com"], a[href^="https://www.nysmah.com"]').length;
  // Blocks are joined with a space: textContent runs "…Arabia</h2><p>Every…"
  // together and would count two words as one.
  const blocks = [...doc.body.querySelectorAll("h2, h3, p, li")];
  const whole = blocks.length ? blocks.map(text).join(" ") : text(doc.body);
  const length = words(whole);
  const empties = [...doc.querySelectorAll("h2, h3, li")].some((element) => !text(element));
  const pageName = clean(name).toLowerCase();

  return [
    {
      key: "headline",
      ok: Boolean(headline) && (!pageName || headline.toLowerCase().includes(pageName)),
      label: "Headline names the page",
      advice: name ? `Put “${name}” in the headline: it is what shoppers search for.` : "Add a headline.",
    },
    {
      key: "headlineLength",
      ok: headline.length >= 15 && headline.length <= 70,
      label: "Headline is 15 to 70 characters",
      advice: `${headline.length} now.`,
    },
    {
      key: "length",
      ok: length >= 50 && length <= 300,
      label: "Between 50 and 300 words",
      advice: `${length} now. Say what is here, from which brands, and why to buy from Nysmah.`,
    },
    {
      key: "saudi",
      ok: lang === "ar" ? /السعودية|المملكة/.test(whole) : /saudi arabia/i.test(whole),
      label: "Says Saudi Arabia",
      advice: "Say where you deliver: Saudi Arabia.",
    },
    {
      key: "links",
      ok: links >= 2,
      label: "Links to two or more of our pages",
      advice: `${links} now. Use the link button to add our pages.`,
    },
    {
      key: "complete",
      ok: !empties,
      label: "Nothing left empty",
      advice: "Fill or remove the empty headline, bullet or section.",
    },
  ];
};
